<template>
    <div class="hidden md:flex md:flex-shrink-0">
        <div class="flex flex-col w-60">
            <div class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-gray-900">
                <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                    <div class="flex items-center justify-center flex-shrink-0 h-16 px-4">
                        <a href="http://apexo.ca/">
                            <img alt="ApexO" class="h-12 w-auto" src="../../assets/logo.png">
                        </a>
                    </div>

                    <div class="h-0 flex-1 flex flex-col overflow-y-auto">
                        <nav class="flex-1 px-2 py-4 space-y-2">
                            <!--                            <nav-item :text="$t('global.nav.dashboard')" view="dashboard" />-->

                            <nav-item :text="$t('global.nav.orders')" view="orders" />

                            <nav-item :text="$t('global.nav.activations')" view="activations" />

                            <!-- <nav-item :text="$t('global.nav.deliveries')" view="deliveries" /> -->
                        </nav>
                    </div>
                </div>

                <div class="flex-shrink-0 flex p-4">
                    <div class="flex-shrink-0 w-full group block space-y-4">
                        <div class="flex items-center">
                            <div>
                                <img alt="" class="inline-block h-9 w-9 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80">
                            </div>

                            <div class="ml-3">
                                <p class="text-sm leading-5 font-medium text-gray-200">
                                    {{ `${authUser.first_name} ${authUser.last_name}` }}
                                </p>

                                <p class="text-xs leading-4 font-medium text-gray-300 hover:text-gray-500 transition ease-in-out duration-150 cursor-pointer" @click="logOut">
                                    {{ $t('global.setting.dropdown.disconnect') }}
                                </p>
                            </div>
                        </div>

                        <div class="border-t border-gray-700 pt-2 text-gray-400 text-xs">
                            <p>
                                © Copyright 2021 ApexO Inc.
                            </p>

                            <p>
                                {{ $t('global.allRightsReserved') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import NavItem from './NavItem.vue';

    export default {
        components: { NavItem },

        computed: {
            ...mapState([
                'authUser',
            ]),
        },

        methods: {
            ...mapActions([
                'clearAuthUser',
            ]),

            logOut() {
                this.clearAuthUser();
            },
        },
    };
</script>
